<script setup lang="ts">
// A list of rows, edge to edge in a flush Panel, divided by hairlines. Put ListItems in it.
defineProps<{ label?: string }>();
</script>

<template>
  <ul class="itc-list" :aria-label="label">
    <slot />
  </ul>
</template>

<style scoped>
.itc-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
